import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import {setPostCreateKeys} from '../../store/thunk/setPostCreateKeys';
import { setGetViewKeys } from '../../store/thunk/setGetViewKeys';

const useStyles = makeStyles(() => ({
    root: {
        padding: '0 20px'
    },
    wrapBlock: {
        margin: '12px 0',
        display: 'flex',
        padding: '20px',
        background: '#1b2039',
        alignItems: 'center',
        borderRadius: '8px',
    },
    wrapLabel: {
        display: 'flex', flexDirection: 'column', width: 500
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    textField: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        marginBottom: 12
    }
}))

const ViewKeys = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const onSubmit = (store) => {
        dispatch(setPostCreateKeys(store));
    }

    React.useEffect(() => {
        dispatch(setGetViewKeys())
    }, [])

  
    const initialValues = useSelector(state => state.key.view);
 
    const enableReinitialize = true;
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    return (
        <div className={classes.root}>
            <Title label="Ключи"/>
            <div className={classes.wrapBlock}> 
                <FormikContext.Provider value={formik}>
                    <form>
                        <label htmlFor="qiwi_public_key" className={classes.wrapLabel}>
                            <div>
                                <h3 style={{color: '#fff'}}>Оборот: <span style={{color: 'red'}}>{initialValues.amountSum} Р</span></h3>
                            </div>
                            <span className={classes.helper}>Public key</span>
                            <input 
                                type="text" 
                                name="qiwi_public_key" 
                                id="qiwi_public_key" 
                                className={classes.textField}
                                value={formik.values.qiwi_public_key} 
                                onChange={(v) => formik.setFieldValue('qiwi_public_key', v.target.value)}/>
                        </label>
                        <label htmlFor="qiwi_secret_key" className={classes.wrapLabel}>
                            <span className={classes.helper}>Secret key</span>
                            <input 
                                type="text" 
                                name="qiwi_secret_key" 
                                id="qiwi_secret_key" 
                                className={classes.textField}
                                value={formik.values.qiwi_secret_key} 
                                onChange={(v) => formik.setFieldValue('qiwi_secret_key', v.target.value)}/>
                        </label>
                        <label htmlFor="qiwi_oauth" className={classes.wrapLabel}>
                            <span className={classes.helper}>Oauth</span>
                            <input 
                                type="text" 
                                name="qiwi_oauth" 
                                id="qiwi_oauth" 
                                className={classes.textField}
                                value={formik.values.qiwi_oauth} 
                                onChange={(v) => formik.setFieldValue('qiwi_oauth', v.target.value)}/>
                        </label>
                        <label htmlFor="wallet" className={classes.wrapLabel}>
                            <span className={classes.helper}>Wallet</span>
                            <input 
                                type="text" 
                                name="wallet_key" 
                                id="wallet_key" 
                                className={classes.textField}
                                value={formik.values.wallet} 
                                onChange={(v) => formik.setFieldValue('wallet', v.target.value)}/>
                        </label>
                        <label htmlFor="wallet_key" className={classes.wrapLabel}>
                            <span className={classes.helper}>Wallet key</span>
                            <input 
                                type="text" 
                                name="wallet_key" 
                                id="wallet_key" 
                                className={classes.textField}
                                value={formik.values.wallet_key} 
                                onChange={(v) => formik.setFieldValue('wallet_key', v.target.value)}/>
                        </label>
                        <label htmlFor="max_amount_for_withdrawals" className={classes.wrapLabel}>
                            <span className={classes.helper}>Макс. сумма вывода без подтверждения</span>
                            <input 
                                type="number" 
                                name="max_amount_for_withdrawals" 
                                id="max_amount_for_withdrawals" 
                                className={classes.textField}
                                value={formik.values.max_amount_for_withdrawals} 
                                onChange={(v) => {
                                        formik.setFieldValue('max_amount_for_withdrawals', v.target.value)
                                }}/>
                        </label>
                        <label htmlFor="count_withdrawals_of_day" className={classes.wrapLabel}>
                            <span className={classes.helper}>Кол-во раз для вывода в сутки без подтверждения</span>
                            <input 
                                type="number" 
                                name="count_withdrawals_of_day" 
                                id="count_withdrawals_of_day" 
                                className={classes.textField}
                                value={formik.values.count_withdrawals_of_day} 
                                onChange={(v) => formik.setFieldValue('count_withdrawals_of_day', v.target.value)}/>
                        </label>
                        <div style={{marginTop: 12}}>
                            <span style={{
                                color: '#141b33',
                                cursor: 'pointer',
                                padding: '10px',
                                background: '#ffc324',
                                borderRadius: '4px',
                            }}
                                onClick={() => formik.submitForm()}
                            >Сохранить</span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default ViewKeys;